/**
 Created by zhyp on 2015/10/19. 切换开关
 html: <trs-radio ckstatus="open" ckcallback="test(!open)"></trs-radio>
       <trs-radio ckstatus="open2" ckdisabled="true"></trs-radio>
 description: ckstatus //选中状态
              ckcallback //回调函数 函数自己另外定义
              ckdisabled //true 禁止编辑 其他可编辑

**/
"use strict";
angular.module("util.trsRadio", []).directive("trsRadio",["$timeout", function($timeout) {
    return {
        restrict: "E",
        replace: false,
        templateUrl: "./components/util/trsRadio/trsradio.html",
        scope: {
            ckstatus: "=",
            ckcallback: "&",
            ckdisabled: "=",
            ckstyle: "@",
            cklabel: "@",
            ckname: "@",
            ckvalue: "@" //开关打开时左侧显示的文字（限1个汉字）
        },
        controller: function($scope) {

        },
        link: function(scope, element, attrs, controller) {
            if (typeof scope.ckstatus === "undefined") {
                scope.ckstatus = false;
            }
            scope.ckstyle = scope.ckstyle || "";
            scope.cklabel = scope.cklabel || "";
            scope.ckname = scope.ckname || "";
            scope.ckvalue = scope.ckvalue || "";
            scope.swtichBtn = function() {
                if (scope.ckdisabled) {
                    return false;
                }
                $timeout(function() {
                    scope.ckcallback();
                });
            };
        }
    };
}]).directive("smartCheckBox", function() {
    return {
        restrict: "E",
        replace: false,
        templateUrl: "./components/util/trsRadio/smartCheckBox.html",
        scope: {
            ckstatus: "=",
            ckdisabled: "=",
            name: "@",
            callback:'&'
        },
        link: function(scope, element, attrs, controller) {
            if (typeof scope.ckstatus === "undefined") {
                scope.ckstatus = false;
            }
            scope.name = scope.name || "";
            scope.swtichBtn = function() {
                if (scope.ckdisabled) {
                    return false;
                }
                scope.ckstatus = !scope.ckstatus;
                scope.callback()
            };
        }
    };
});
